import QRCode from 'qrcode';

/**
 * Render `text` as a QR code and return a PNG data-URL, suitable for embedding
 * into an @react-pdf/renderer <Image src=...>.
 */
export const generateQrDataUrl = async (text: string): Promise<string> => {
  return QRCode.toDataURL(text, {
    errorCorrectionLevel: 'M',
    margin: 1,
    width: 512,
  });
};
